import { IconBrandMastercard, IconBrandVisa, IconCreditCard } from '@tabler/icons-react';

const paymentIcons = {
  visa: { icon: IconBrandVisa },
  mastercard: { icon: IconBrandMastercard },
  amex: { icon: IconCreditCard },
  unknown: { icon: IconCreditCard },
};

export default paymentIcons;
